/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum AIAgentFeatureFlags {
    aiag_2602_b_mcp = 'aiag_2602_b_mcp',
    aiag_2603_b_concierge = 'aiag_2603_b_concierge',
    aiag_2504_f_test_flag = 'aiag_2504_f_test_flag',
    aiag_2603_f_portfolio_health_dashboard = 'aiag_2603_f_portfolio_health_dashboard',
    aiag_2603_f_waste_analysis_dashboard = 'aiag_2603_f_waste_analysis_dashboard',
    aiag_2603_f_expiry_renewal_dashboard = 'aiag_2603_f_expiry_renewal_dashboard',
    aiag_2604_f_knowledge_graph_browser = 'aiag_2604_f_knowledge_graph_browser',
    aiag_2604_b_ro_agent = 'aiag_2604_b_ro_agent',
    aiag_2604_b_assessment_agent = 'aiag_2604_b_assessment_agent',
    aiag_2604_b_finops_agent = 'aiag_2604_b_finops_agent',
    aiag_2604_b_bedrock_agent = 'aiag_2604_b_bedrock_agent',
    aiag_2604_b_anthropic_agent = 'aiag_2604_b_anthropic_agent',
    aiag_2604_b_graphion_agent = 'aiag_2604_b_graphion_agent',
    aiag_2605_a_report_annotations = 'aiag_2605_a_report_annotations',
    aiag_2605_b_mcp_resource_utilisation_tool = 'aiag_2605_b_mcp_resource_utilisation_tool'
}
